module.exports = __webpack_public_path__ + "media/images/guide_no_avatar-5e027044b70c017be340f214b47829dc.png";